import logo from './logo.svg';
import './App.css';
import Test from './components/Test'
import NavBar from './components/NavBar';
import ToolsUsed from './components/ToolsUsed';
import Hero from './components/Hero';
import AboutMe from './components/AboutMe';
import Work from './components/Work';
import Project from './components/Project';
import Volunteer from './components/Volunteer';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App" style={{backgroundColor: '#0F1624'}}>
      <NavBar />
      <br /><br />
      <ToolsUsed />
      <br /><br />
      <Hero />
      <br /><br />
      <AboutMe />
      <br /><br />
      <Work />
      <br /><br />
      <Project />
      <br /><br />
      <Volunteer />
      <br /><br />
      <Contact />
      <br /><br />
    </div>
  );
}


export default App;
